export interface IResetPasswordIndicator {
  id: string;
  name: string;
  message: string;
}

const ResetPasswordFormIndicators: IResetPasswordIndicator[] = [
  {
    id: 'has-one-uppercase-char',
    name: 'hasOneUppercaseChar',
    message: 'reset.pass.form.indicator.hasOneUppercaseChar'
  },
  {
    id: 'has-one-lowercase-char',
    name: 'hasOneLowercaseChar',
    message: 'reset.pass.form.indicator.hasOneLowercaseChar'
  },
  {
    id: 'more-tha-ten-chars',
    name: 'moreThanTenChars',
    message: 'reset.pass.form.indicator.moreThanTenChars'
  },
  {
    id: 'has-one-number',
    name: 'hasOneNumber',
    message: 'reset.pass.form.indicator.hasOneNumber'
  },
];

export default ResetPasswordFormIndicators;
